import { render, staticRenderFns } from "./VAppMultipleBranchSelectorItem.vue?vue&type=template&id=5172aa3a&scoped=true"
import script from "./VAppMultipleBranchSelectorItem.vue?vue&type=script&lang=js"
export * from "./VAppMultipleBranchSelectorItem.vue?vue&type=script&lang=js"
import style0 from "./VAppMultipleBranchSelectorItem.vue?vue&type=style&index=0&id=5172aa3a&prod&scoped=true&lang=css"
import style1 from "./VAppMultipleBranchSelectorItem.vue?vue&type=style&index=1&id=5172aa3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5172aa3a",
  null
  
)

export default component.exports